import { useState, } from "react";
import { useDispatch } from "react-redux";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import { getLocalizedString } from "@icarius-localization/strings";
import { openDialogAction } from "@icarius-common/dialog/actions";

const useQuestions = (questions, submitCallback) => {

    const [selectedQuestion, setSelectedQuestion] = useState(null);
    const [questionFormIsOpen, setQuestionFormIsOpen] = useState(false);

    const dispatch = useDispatch();

    const handleOpenCreateQuestionForm = () => {
        setQuestionFormIsOpen(true);
    }

    const handleOpenUpdateQuestionForm = (gridRef) => {
        let selectedRows = gridRef.api.getSelectedRows();
        if (selectedRows.length !== 1) {
            dispatch(openSnackbarAction({ msg: getLocalizedString("mustSelectOneRow"), severity: "warning" }));
            return;
        }
        
        setSelectedQuestion(selectedRows[0]);
        setQuestionFormIsOpen(true);
    }

    const handleCloseQuestionForm = () => {
        setQuestionFormIsOpen(false);
        setSelectedQuestion(null);
    }

    const handleCreateQuestion = (dataToSend) => {
        submitCallback([...questions, dataToSend]);
        handleCloseQuestionForm();
    }

    const handleUpdateQuestion = (dataToSend) => {
        submitCallback(questions.map((question) => {
            if (question.index === selectedQuestion.index) return dataToSend;
            return question;
        }));
        handleCloseQuestionForm();
    }

    const handleOpenDeleteQuestionDialog = (gridRef) => {
        let selectedRows = gridRef.api.getSelectedRows();
        if (selectedRows.length !== 1) {
            dispatch(openSnackbarAction({ msg: getLocalizedString("mustSelectOneRow"), severity: "warning" }));
            return;
        }

        const questionIndex = selectedRows[0].index;
        dispatch(openDialogAction({
            title: getLocalizedString("attention"),
            msg: getLocalizedString("doYouWantToDeleteQuestion"),
            onConfirm: () => submitCallback(questions.filter((question) => question.index !== questionIndex)),
        }));
    }

    const state = {
        selectedQuestion,
        questionFormIsOpen,
    }

    const handlers = {
        handleOpenCreateQuestionForm,
        handleOpenUpdateQuestionForm,
        handleCloseQuestionForm,
        handleOpenDeleteQuestionDialog,
        handleCreateQuestion,
        handleUpdateQuestion,
    }

    return {
        state,
        handlers,
    }
}

export default useQuestions;